import Component from './LengthBadge.component';

export default Component;
